import React, { useState, useEffect, useCallback } from 'react';
import { Modal } from 'react-bootstrap';
import Countdown from 'react-countdown';

const ADsModal = ({ show, onHide, handleShowModalDL }) => {
    const [filledBoxes, setFilledBoxes] = useState(0);
    const [endTime, setEndTime] = useState(null);
    const [remainingTime, setRemainingTime] = useState(null); // Thời gian còn lại
    const totalTime = 19000;
    const boxCount = 5;
    const interval = totalTime / boxCount;

    // Thiết lập thời gian đếm ngược ban đầu
    useEffect(() => {
        if (show) {
            const newEndTime = endTime || Date.now() + totalTime;
            setEndTime(newEndTime);
            setRemainingTime(newEndTime - Date.now());
        }
    }, [show, endTime, totalTime]);

    useEffect(() => {
        if (!show || !remainingTime) return;

        let timer;
        if (!document.hidden) {
            timer = setInterval(() => {
                const newRemainingTime = endTime - Date.now();

                if (newRemainingTime <= 0) {
                    setFilledBoxes(boxCount);
                    clearInterval(timer);
                    onHide();
                    handleShowModalDL();
                } else {
                    setRemainingTime(newRemainingTime);
                    const newFilledBoxes = Math.floor((totalTime - newRemainingTime) / interval);
                    setFilledBoxes(Math.min(newFilledBoxes, boxCount));
                }
            }, interval);
        }

        return () => clearInterval(timer);
    }, [show, remainingTime, endTime, interval, totalTime, onHide, handleShowModalDL]);

    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.hidden) {
                // Lưu thời gian còn lại khi tab bị ẩn
                setRemainingTime(endTime - Date.now());
            } else if (remainingTime) {
                // Cập nhật lại endTime khi quay lại
                setEndTime(Date.now() + remainingTime);
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
    }, [endTime, remainingTime]);

    const handleCountdownComplete = useCallback(() => {
        onHide();
        handleShowModalDL();
    }, [onHide, handleShowModalDL]);

    // Render modal
    return (
        <Modal show={show} onHide={onHide} centered className="modal-download-ads">
            <Modal.Body className="text-center">
                <h5>素材をダウンロードできるまで</h5>
                {remainingTime !== null && (
                    <Countdown
                        date={Date.now() + remainingTime}
                        onComplete={handleCountdownComplete}
                        renderer={({ minutes, seconds }) => (
                            <span className="countdown-timer">
                                {minutes}:{seconds < 10 ? `0${seconds}` : seconds}
                            </span>
                        )}
                    />
                )}
                <div className="d-flex justify-content-center mt-3">
                    {[...Array(boxCount)].map((_, index) => {
                        const isFilled = index <= filledBoxes;
                        return (
                            <div
                                key={index}
                                className={`progress-box mx-1 ${isFilled ? 'filled' : ''}`}
                            ></div>
                        );
                    })}
                </div>
                <p className="mt-3">待たずにダウンロードするには？</p>
            </Modal.Body>
        </Modal>
    );
};

export default ADsModal;
